import { t } from 'i18next';

export const getStatusConfig = () => ({
  added: {
    text: t('ui.compare.status-add-success'),
    buttonText: t('ui.compare.status-button-go-to'),
    mode: 'added',
    redirectTo: '/compare/',
  },
  removed: {
    text: t('ui.compare.status-delete-success'),
    buttonText: t('ui.compare.status-button-revert'),
    mode: 'removed',
  },
  errorAdd: {
    text: t('ui.compare.status-add-error'),
    buttonText: t('ui.compare.status-button-retry'),
    mode: 'error',
  },
  errorRemove: {
    text: t('ui.compare.status-delete-error'),
    buttonText: t('ui.compare.status-button-retry'),
    mode: 'error',
  },
  productListCountAlert: {
    header: t('ui.compare.status-alert-list-header'),
    text: t('ui.compare.status-add-alert'),
    buttonText: t('ui.compare.status-button-go-to-list'),
    mode: 'alert',
    redirectTo: '/compare/',
  },
  listCountAlert: {
    header: t('ui.compare.status-alert-lists-header'),
    text: t('ui.compare.status-add-alert'),
    buttonText: t('ui.compare.status-button-go-to-list'),
    mode: 'alert',
    redirectTo: '/compare/',
  },
});
